<div class="row">
  <div class="col-12">
    <div class="mat-h3">KYB</div>
  </div>
</div>

<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>View</mat-label>
      <mat-select [ngModel]="activeQueueSelection" (selectionChange)="selectQueue($event.value)">
        @for (selector of queueSelectors; track selector.value) {
          <mat-option [value]="selector.value">
            {{selector.label}} ({{queueCount(selector.count)}})
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Reconciliation</mat-label>
      <mat-select [(ngModel)]="reconciliationFilter">
        <mat-option value="ALL">All</mat-option>
        <mat-option value="PENDING">Pending review</mat-option>
        <mat-option value="RECONCILED">Reconciled</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Sort</mat-label>
      <mat-select [(ngModel)]="sortMode" (selectionChange)="onSortModeChange()">
        <mat-option value="PRIORITY">Priority</mat-option>
        <mat-option value="OLDEST">Oldest first</mat-option>
        <mat-option value="LATEST">Latest update</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" multiple (selectionChange)="onStatusFilterChange()">
        <mat-select-trigger>{{statusTriggerLabel()}}</mat-select-trigger>
        <mat-option [value]="allStatuses">All</mat-option>
        @for (option of statusOptions; track option.value) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Application state</mat-label>
      <mat-select [(ngModel)]="applicationStateFilter">
        <mat-option value="SUBMITTED">Submitted</mat-option>
        <mat-option value="DRAFT">Draft</mat-option>
        <mat-option value="ALL">All</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field class="search">
      <input matInput type="text" placeholder="Search by application ID, ABN, ACN or entity ID"
        [(ngModel)]="searchFilter" (keyup.enter)="applyFilters()">
      <span class="mdi mdi-magnify" matPrefix></span>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Created from</mat-label>
      <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="col-lg-3 col-md-6 col-sm-12">
    <mat-form-field appearance="outline">
      <mat-label>Created to</mat-label>
      <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="queue-toolbar">
      @if (selectedCount()) {
        <div class="action-buttons">
          <button mat-flat-button color="primary" (click)="retrySelected()"
            [disabled]="isSelectionOverLimit() || isActionRunning">
            @if (retryFeedback?.state === 'progress') {
              <span class="mdi mdi-loading retry-spinner" aria-hidden="true"></span>
              Retrying selected...
            } @else {
              <span class="mdi mdi-refresh" aria-hidden="true"></span>
              Retry selected ({{selectedCount()}})
            }
          </button>
          @if (isSelectionOverLimit()) {
            <span class="selection-warning">Select at most {{maxBatch}} at a time</span>
          }
        </div>
      }
      <div class="action-buttons refresh-status queue-actions">
        <button mat-flat-button color="primary" (click)="applyFilters()">Apply Filters</button>
        @if (hasFilters) {
          <button mat-stroked-button color="primary" (click)="clearFilters()">
            <span class="mdi mdi-close"></span>
            Clear
          </button>
        }
        <span [class.refresh-error]="refreshFailed">{{lastRefreshedLabel()}}</span>
        <button mat-stroked-button color="primary" (click)="manualRefresh()"
          [disabled]="isLoading || isActionRunning">
          <span class="mdi mdi-refresh"></span>
          Refresh
        </button>
      </div>
    </div>
  </div>
</div>

@if (retryFeedback) {
  <div class="row">
    <div class="col-12">
      <section class="retry-feedback" [ngClass]="'retry-feedback-' + retryFeedback.state"
        [attr.role]="retryFeedback.state === 'error' ? 'alert' : 'status'"
        [attr.aria-live]="retryFeedback.state === 'error' ? 'assertive' : 'polite'">
        @if (retryFeedback.state === 'progress') {
          <span class="mdi mdi-loading retry-feedback-icon retry-spinner" aria-hidden="true"></span>
        } @else if (retryFeedback.state === 'success') {
          <span class="mdi mdi-check-circle-outline retry-feedback-icon" aria-hidden="true"></span>
        } @else {
          <span class="mdi mdi-alert-outline retry-feedback-icon" aria-hidden="true"></span>
        }
        <div class="retry-feedback-copy">
          <div class="retry-feedback-title">{{retryFeedback.title}}</div>
          <div>{{retryFeedback.message}}</div>
        </div>
        @if (retryFeedback.actionLabel) {
          <button mat-stroked-button color="primary" (click)="openRetryResults()">
            {{retryFeedback.actionLabel}}
          </button>
        }
        @if (retryFeedback.state !== 'progress') {
          <button mat-icon-button aria-label="Dismiss retry update" (click)="dismissRetryFeedback()">
            <span class="mdi mdi-close" aria-hidden="true"></span>
          </button>
        }
      </section>
    </div>
  </div>
}

<div class="row">
  <div class="col-12">
    @if (isLoading) {
      <custom-content-loader type="list"></custom-content-loader>
    }
    <div [ngClass]="{hidden: isLoading, 'table-section': true, 'pb-3': true}">
      <table mat-table [dataSource]="dataSource" class="width-100 mb-2" multiTemplateDataRows>
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            @if (canRecoverRuns) {
              <mat-checkbox color="primary" (change)="toggleAllRows()"
                aria-label="Select all retryable runs on this page"
                [checked]="isAllSelected()" [indeterminate]="hasPartialSelection()"
                [disabled]="isActionRunning">
              </mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let element">
            @if (isSelectable(element)) {
              <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleRow(element)"
                [checked]="selection.isSelected(element)"
                [disabled]="isActionRunning"
                [attr.aria-label]="'Select application ' + element.applicationId">
              </mat-checkbox>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="applicationId">
          <th mat-header-cell *matHeaderCellDef>App ID</th>
          <td mat-cell *matCellDef="let element">
            <a [routerLink]="applicationLink(element)" (click)="$event.stopPropagation()">
              {{element.applicationId}}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="legalName">
          <th mat-header-cell *matHeaderCellDef>Entity</th>
          <td mat-cell *matCellDef="let element" class="td-width ellipsis"
            [matTooltip]="element.legalName || ''" [matTooltipDisabled]="!element.legalName">
            {{element.legalName || '-'}}
            <div class="date-text">{{entityRoles(element)}} · {{businessNumber(element)}}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="reason">
          <th mat-header-cell *matHeaderCellDef>Reason</th>
          <td mat-cell *matCellDef="let element">{{reasonsLabel(element)}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            @if (isRunRetrying(element)) {
              <span class="status-pending retrying-status">
                <span class="mdi mdi-loading retry-spinner" aria-hidden="true"></span>
                Retrying
              </span>
            } @else {
              <span [ngClass]="statusClass(element.latestRun.status)">
                {{statusLabel(element.latestRun.status)}}
              </span>
            }
            @if (element.latestReevaluation) {
              <div class="date-text">
                Risk: {{reevaluationStatusLabel(element.latestReevaluation.status)}}
              </div>
            }
            @if (element.reconciliationStatus) {
              <div class="date-text">{{reconciliationStatusLabel(element.reconciliationStatus)}}</div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="lastUpdate">
          <th mat-header-cell *matHeaderCellDef>Last update</th>
          <td mat-cell *matCellDef="let element">{{formatDate(element.latestRun.lastUpdate)}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions"></th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <div class="row-actions">
              @if (needsRunRecovery(element) && canRecoverRuns) {
                <button mat-stroked-button color="primary" (click)="recoverRun(element)" [disabled]="isActionRunning">
                  @if (isRunRetrying(element)) {
                    <span class="mdi mdi-loading retry-spinner" aria-hidden="true"></span>
                    Retrying...
                  } @else {
                    Retry
                  }
                </button>
              }
              @if (needsReevaluationRecovery(element) && canReevaluate(element)) {
                <button mat-stroked-button color="primary" (click)="retryReevaluation(element)"
                  [disabled]="isActionRunning">
                  Re-evaluate
                </button>
              }
              @if (needsReconciliation(element)) {
                <a mat-stroked-button color="primary" [routerLink]="reconciliationLink(element)">Reconcile</a>
              }
              <button mat-icon-button class="diagnostics-toggle"
                [attr.aria-label]="(isExpanded(element) ? 'Hide' : 'Show') + ' details for application ' + element.applicationId"
                [attr.aria-expanded]="isExpanded(element)"
                [attr.aria-controls]="diagnosticsId(element)"
                (click)="toggleExpanded(element)">
                <span class="mdi" [ngClass]="isExpanded(element) ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                  aria-hidden="true"></span>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" class="expanded-row" [attr.colspan]="displayedColumns.length">
            <div class="example-element-detail"
              [@detailExpand]="isExpanded(element) ? 'expanded' : 'collapsed'">
              <section class="diagnostics" [id]="diagnosticsId(element)"
                [attr.aria-label]="'Details for application ' + element.applicationId">
                <div class="row mt-3">
                  <div class="col-2 title">Entity</div>
                  <div class="col-10">{{element.legalName || '-'}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">ABN / ACN</div>
                  <div class="col-10">{{businessNumberDetail(element)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Roles</div>
                  <div class="col-10">{{entityRoles(element)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Entity type</div>
                  <div class="col-10">{{element.entityType || '-'}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Entity customer reference</div>
                  <div class="col-10">{{element.latestRun.entityCustomerReference}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Run ID</div>
                  <div class="col-10">{{element.latestRun.id}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Reconciliation</div>
                  <div class="col-10">{{reconciliationStatusLabel(element.reconciliationStatus)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Triggered by</div>
                  <div class="col-10">{{triggeredBy(element.latestRun)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Attempts</div>
                  <div class="col-10">{{attempts(element.latestRun)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Created</div>
                  <div class="col-10">{{formatDate(element.latestRun.createdAt)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Last update</div>
                  <div class="col-10">{{formatDate(element.latestRun.lastUpdate)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">FrankieOne entity ID</div>
                  <div class="col-10">{{element.latestRun.frankieOneEntityId || '-'}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Request ID</div>
                  <div class="col-10">{{element.latestRun.requestId || '-'}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Workflow execution ID</div>
                  <div class="col-10">{{element.latestRun.workflowExecutionId || '-'}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Workflow / service</div>
                  <div class="col-10">{{element.latestRun.workflowName}} / {{element.latestRun.serviceName}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Initiated</div>
                  <div class="col-10">{{formatDate(element.latestRun.initiatedAt)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Callback received</div>
                  <div class="col-10">{{formatDate(element.latestRun.callbackReceivedAt)}}</div>
                </div>
                <div class="row mt-2">
                  <div class="col-2 title">Completed</div>
                  <div class="col-10">{{formatDate(element.latestRun.completedAt)}}</div>
                </div>
                @if (element.latestRun.lastError) {
                  <div class="row mt-2">
                    <div class="col-2 title">Last error</div>
                    <div class="col-10 error-text">
                      {{element.latestRun.lastError}}
                      <div class="error-time">{{formatDate(element.latestRun.lastErrorAt)}}</div>
                    </div>
                  </div>
                }

                <div class="row detail-section">
                  <div class="col-12 title detail-section-title reevaluation-header">
                    Risk re-evaluations ({{element.reevaluations.length}})
                    @if (canReevaluate(element) && !needsReevaluationRecovery(element)) {
                      <button mat-stroked-button color="primary" class="reevaluate-button"
                        matTooltip="Re-score this entity in FrankieOne, patching the ANZSIC, channel and product first where the entity has an ANZSIC. Does not start a new KYB workflow."
                        (click)="retryReevaluation(element)" [disabled]="isActionRunning">
                        <span class="mdi mdi-refresh"></span>
                        Re-evaluate
                      </button>
                    }
                  </div>
                </div>
                @if (element.reevaluations.length) {
                  <div class="row mt-2 reevaluation-row reevaluation-head">
                    <div class="col-2">Status</div>
                    <div class="col-2">Trigger</div>
                    <div class="col-1">ANZSIC</div>
                    <div class="col-2">Requested</div>
                    <div class="col-2">Responded</div>
                    <div class="col-1">Took</div>
                    <div class="col-2">Risk</div>
                  </div>
                  @for (reevaluation of element.reevaluations; track reevaluation.id) {
                    <div class="row mt-1 reevaluation-row">
                      <div class="col-2">
                        <span [ngClass]="reevaluationStatusClass(reevaluation.status)">
                          {{reevaluationStatusLabel(reevaluation.status)}}
                        </span>
                      </div>
                      <div class="col-2">{{reevaluationTriggerLabel(reevaluation)}}</div>
                      <div class="col-1">{{reevaluation.anzsicCode || '-'}}</div>
                      <div class="col-2">{{formatDate(reevaluation.requestedAt)}}</div>
                      <div class="col-2">{{formatDate(reevaluation.respondedAt)}}</div>
                      <div class="col-1">{{reevaluationResponseTime(reevaluation)}}</div>
                      <div class="col-2">{{reevaluationRisk(reevaluation)}}</div>
                      <div class="col-12 reevaluation-meta">
                        Run {{reevaluation.applicationKybRunId}}
                        &middot; {{triggeredBy(reevaluation)}}
                        &middot; attempt {{reevaluation.attemptCount}}
                        @if (reevaluation.evaluateOnly) {
                          &middot; evaluate only
                        }
                        @if (reevaluation.workflowExecutionId) {
                          &middot; execution {{reevaluation.workflowExecutionId}}
                        }
                      </div>
                      @if (reevaluation.lastError) {
                        <div class="col-12 error-text mt-1">{{reevaluation.lastError}}</div>
                      }
                    </div>
                  }
                } @else {
                  <div class="row mt-2">
                    <div class="col-12 no-reevaluations">
                      No risk re-evaluation has been sent for this entity.
                    </div>
                  </div>
                }

                @if (element.previousRuns.length) {
                  <div class="row detail-section">
                    <div class="col-12 title detail-section-title">
                      Previous runs ({{element.previousRuns.length}})
                    </div>
                  </div>
                  @for (run of element.previousRuns; track run.id) {
                    <div class="row mt-2 previous-run">
                      <div class="col-2">
                        <span [ngClass]="statusClass(run.status)">{{statusLabel(run.status)}}</span>
                      </div>
                      <div class="col-10">
                        Run {{run.id}} · Attempts {{attempts(run)}} · {{triggeredBy(run)}} · {{formatDate(run.createdAt)}}
                        @if (run.lastError) {
                          <div class="error-text">{{run.lastError}}</div>
                        }
                      </div>
                    </div>
                  }
                }
              </section>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
          [class.example-expanded-row]="isExpanded(element)"
          [class.retrying-row]="isRunRetrying(element)"
          (click)="toggleExpanded(element)">
        </tr>
        <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="example-detail-row"></tr>
      </table>

      @if (!dataSource.length) {
        <div class="no-records">No records found</div>
      }

      <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
        [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)">
      </app-custom-paginator>
    </div>
  </div>
</div>
